import styled from "styled-components";

export const ContainerFlex = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.medium};
  padding-bottom: 20px;

  @media (min-width: 1921px) {
    height: 100%;
  }

  @media (max-width: 1300px) {
    flex-direction: column;
    height: auto;
  }
`;

export const ContainerColumnFlex = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;

  @media (max-width: 1300px) {
    flex-direction: column-reverse;
    gap: ${({ theme }) => theme.spacing.medium};
    height: auto;
  }
`;

export const CardsColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};

  @media (max-width: 1300px) {
    flex-direction: row;
    width: 100%;
  }

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const DatatablesColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: clip;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`;

export const CardsFlex = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;

  @media (max-width: 400px) {
    flex-direction: column;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: start;
  margin-top: ${({ theme }) => theme.spacing.medium};

  @media (max-width: 1300px) {
    margin-top: 0;
  }
`;

export const ButtonLabel = styled.div`
  margin-left: 5px;
`;

export const SearchContainer = styled.div`
  width: 300px;

  @media (max-width: 700px) {
    width: 100%;
  }
`;
